<template>
  <div class="navbar-container main-menu-content">
    <horizontal-nav-menu-items :items="activeMenuItems" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import HorizontalNavMenuItems from './components/horizontal-nav-menu-items/HorizontalNavMenuItems.vue'

export default {
  components: {
    HorizontalNavMenuItems,
  },
  computed: {
  ...mapState('hwUiMenu', ['activeMenuItems']),
  },
}
</script>

<style lang="scss">
@import "~@hw-ui/scss/base/core/menu/menu-types/horizontal-menu.scss";
</style>
